<template>
	<v-menu>
		<template v-slot:activator="{ props }">
			<v-btn
				icon
				color="default"
				v-bind="props"
				aria-label="Teilen"
			>
				<v-icon icon="ri-share-fill" />
			</v-btn>
		</template>
		<v-list>
			<v-list-item @click="shareToFacebook(location)">
				<v-list-item-title>
					<v-icon
						icon="ri-facebook-fill"
						class="mr-2"
						aria-label="Teilen auf Facebook"
					/>
					Facebook
				</v-list-item-title>
			</v-list-item>
			<v-list-item @click="shareViaEmail(location)">
				<v-list-item-title>
					<v-icon
						icon="ri-mail-fill"
						class="mr-2"
						aria-label="Teilen per Email"
					/>
					Email
				</v-list-item-title>
			</v-list-item>
			<v-list-item @click="shareToWhatsApp(location)">
				<v-list-item-title>
					<v-icon
						icon="ri-whatsapp-fill"
						class="mr-2"
						aria-label="Teilen auf WhatsApp"
					/>
					WhatsApp
				</v-list-item-title>
			</v-list-item>
			<v-list-item @click="shareToTelegram(location)">
				<v-list-item-title>
					<v-icon
						icon="ri-telegram-fill"
						class="mr-2"
						aria-label="Teilen auf Telegram"
					/>
					Telegram
				</v-list-item-title>
			</v-list-item>
		</v-list>
	</v-menu>
</template>

<script setup lang="ts">
import type { CompanyLocation } from '~/types';

const config = useRuntimeConfig();

defineProps<{
	location: typeof CompanyLocation
}>()

const shareToFacebook = (location: typeof CompanyLocation) => {
	const listingUrl = `${config.public.DOMAIN}/listings/${location.id}`;
	const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${listingUrl}`;
	window.open(shareUrl, '_blank');
}

const shareViaEmail = (location: typeof CompanyLocation) => {
	const listingUrl = `${config.public.DOMAIN}/listings/${location.id}`;
	const shareUrl = `mailto:?subject=Termin bei ${location.name}&body=Schau mal, du kannst hier einen Termin bei ${location.name} buchen! ${listingUrl}`;
	window.open(shareUrl, '_blank');
}

const shareToWhatsApp = (location: typeof CompanyLocation) => {
	const listingUrl = `${config.public.DOMAIN}/listings/${location.id}`;
	const shareUrl = `https://wa.me/?text=Schau mal, du kannst hier einen Termin bei ${location.name} buchen! ${listingUrl}`;
	window.open(shareUrl, '_blank');
}

const shareToTelegram = (location: typeof CompanyLocation) => {
	const listingUrl = `${config.public.DOMAIN}/listings/${location.id}`;
	const shareUrl = `https://t.me/share/url?url=${listingUrl}&text=Schau mal, du kannst hier einen Termin bei ${location.name} buchen!`;
	window.open(shareUrl, '_blank');
}
</script>
